'use client'

import type { PropsWithChildren } from 'react'

import Auth0EnvLock from '@dd3-tech/auth0-env-lock'
import '@dd3-tech/auth0-env-lock/dist/styles.min.css'

const DD360_DOMAIN_AUTH0 = process.env.DD360_DOMAIN_AUTH0
const DD360_CLIENT_ID_AUTH0 = process.env.DD360_CLIENT_ID_AUTH0

export enum ChannelType {
  WEB = 'web',
  MOBILE = 'mobile'
}

interface RequiredAuthDevStageProps {
  children: JSX.Element
  channel?: ChannelType.WEB | ChannelType.MOBILE
}

const RequiredAuthDevStage = ({
  children,
  channel = ChannelType.WEB
}: PropsWithChildren<RequiredAuthDevStageProps>) => {
  return (
    <Auth0EnvLock
      config={{
        domain: DD360_DOMAIN_AUTH0 as string,
        clientID: DD360_CLIENT_ID_AUTH0 as string
      }}
      isDev={
        process.env.NEXT_PUBLIC_STAGE === 'dev' &&
        channel !== ChannelType.MOBILE
      }
    >
      {children}
    </Auth0EnvLock>
  )
}

export default RequiredAuthDevStage
